import type { SxProps, Theme } from '@mui/material/styles';

export type FormattedAmountLayout = 'inline' | 'responsive-stack' | 'stack';

export type AmountLabelPosition = 'left' | 'right';

// A trailing label has a small gap; a leading currency symbol sits flush against the amount.
export const AMOUNT_LABEL_GAP = 0.5;

export const formattedAmountStyles = {
  inlineUnit: { flexWrap: 'wrap', columnGap: AMOUNT_LABEL_GAP, rowGap: 0.5, minWidth: 0, maxWidth: '100%' },
  bonusIcon: { verticalAlign: 'middle', mr: 0.5 },
} as const;

export const getFormattedAmountLayoutSx = (
  layout: FormattedAmountLayout,
  labelPosition: AmountLabelPosition | undefined,
  isTruncated: boolean
): SxProps<Theme> => {
  if (isTruncated) {
    return { display: 'inline' };
  }

  const gap = labelPosition === 'right' ? AMOUNT_LABEL_GAP : 0;
  const stackDirection = labelPosition === 'left' ? 'column-reverse' : 'column';

  switch (layout) {
    case 'stack':
      return { display: 'inline-flex', flexDirection: stackDirection, alignItems: 'flex-start', gap };
    case 'responsive-stack':
      return {
        display: 'inline-flex',
        flexDirection: { xs: stackDirection, sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'baseline' },
        gap,
      };
    default:
      return { display: 'inline-flex', flexDirection: 'row', alignItems: 'baseline', gap };
  }
};
